export default function NotFound() {
  return <div>Notfound</div>;
}
